__webpack_require__.p = "https://bundle.stayforlong.com/20251224.1/_next/";